import { createFileRoute } from '@tanstack/react-router';

import { requireSession } from '~/lib/route-auth';
import { DashboardComponent } from '~/page-components/dashboard';

export const Route = createFileRoute('/dashboard')({
  component: DashboardComponent,
  beforeLoad: async () => {
    await requireSession();
  }
});
